import styled from "styled-components/macro";

export const FormItemWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.8rem;
`;

export const FormItemLabel = styled.label`
  font-size: 1.6rem;
  font-weight: bold;
  margin-left: 0.8rem;
  color: midnightblue;
`;

export const FormItemInput = styled.input`
  font-size: 1.6rem;
  border-radius: 1.6rem;
  padding: 0.8rem;
  border-color: transparent;
  background-color: white;
`;
